import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Ref from "./pages/Ref";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Home from "./pages/Home";
import ErrorCom from "./Components/ErrorCom";
import NotAdmin236 from "./pages/NotAdmin236";
import { AuthContextProvider } from "./context/AuthContext";
import Dashboard from "./pages/admin/Dashboard";
import Settings from "./pages/admin/Settings";
import EditTasks from "./pages/admin/EditTasks";
import AdminAdvertTasks from "./pages/admin/AdminAdvertTasks";
import Search from "./pages/admin/Search";
import Statistics from "./pages/admin/Statistics";
import AdminYoutube from "./pages/admin/AdminYoutube";
import AlphaDogs from "./pages/AlphaDogs";
import Checkout from "./pages/Checkout";
import CartPage from './pages/CartPage';
import AdminOrdersPanel from './pages/admin/AdminOrdersPanel';
import AdminAddProductForm from './pages/admin/AdminAddProductForm';
import AdminStats from './pages/admin/AdminStats';
import ShopPage from "./pages/ShopPage";
import ProductPage from "./pages/ProductPage";
import MyOrdersPage from "./pages/MyOrdersPage";
import DiscountsPage from "./pages/DiscountsPage";
import AdminSupport from './pages/admin/AdminSupport';
import SupportPage from "./pages/SupportPage";
import TermsPage from "./pages/TermsPage";
import FaqPage from "./pages/FaqPage";
import AdminFaqPanel from './pages/admin/AdminFaqPanel';
import ReferralPage from "./pages/ReferralPage";
import AdminCatalogPage from './pages/admin/AdminCatalogPage';


const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorCom />,
    children:[
      {
        path:"/",
        element: <AlphaDogs />,
      },
      {
        path:"/ref",
        element: <Ref />,
      },
            {
        path:"/TermsPage",
        element: <TermsPage />,
      },
            {
        path:"/FaqPage",
        element: <FaqPage />,
      },
      {
        path:"/admin",
        element: <NotAdmin236 />,
      },
            {
        path:"/checkout",
        element: <Checkout />,
      },
                  {
        path:"/cart",
        element: <CartPage />,
      },
                        {
        path:"/shop",
        element: <ShopPage />,
      },
                              {
        path:"/product/:id",
        element: <ProductPage />,
      },
                                    {
        path:"/my-orders",
        element: <MyOrdersPage />,
      },
                                          {
        path:"/discounts",
        element: <DiscountsPage />,
      },
                                                {
        path:"/Support",
        element: <SupportPage />,
      },
                                                      {
        path:"/Partner",
        element: <ReferralPage />,
      },
    ]

  },
  {
    path: "/admin",
    element: <Dashboard />,
    errorElement: <ErrorCom />,
    children:[
      {
        path:"/admin/settings",
        element: <Settings />,
      },
      {
        path:"/admin/managetasks",
        element: <EditTasks />,
      },
      {
        path:"/admin/promo",
        element: <AdminAdvertTasks />,
      },
      {
        path:"/admin/youtube",
        element: <AdminYoutube />,
      },
      {
        path:"/admin/search",
        element: <Search />,
      },
      {
        path:"/admin/stats",
        element: <Statistics />,
      },
            {
        path:"/admin/orders",
        element: <AdminOrdersPanel />,
      },
                  {
        path:"/admin/products",
        element: <AdminAddProductForm />,
      },
                        {
        path:"/admin/stats2",
        element: <AdminStats />,
      },
                              {
        path:"/admin/Support",
        element: <AdminSupport />,
      },
                                    {
        path:"/admin/AdminFaqPanel",
        element: <AdminFaqPanel />,
      },
                                          {
        path:"/admin/AdminCatalogPage",
        element: <AdminCatalogPage />,
      },

    ]
  }
]);


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthContextProvider>
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
  </AuthContextProvider>
);
